<template>
    <section class="resume-section interests-section mb-5">
        <h2 class="resume-section-title text-uppercase font-weight-bold pb-3 mb-3">{{title}}</h2>
        <div class="resume-section-content">
            <ul class="list-unstyled">
                <li class="mb-1" v-for="(item, index) in hobbies" :key="index">
                    <a v-if="item.link.length" :href="item.link">
                        {{item.label}}
                    </a>
                    <template v-else>
                        {{item.label}}
                    </template>
                </li>
            </ul>
        </div>
    </section>
</template>
<script>
    export default {
        name: "Hobbies",
        computed: {
            data() {
                return this.$store.state.hobbies[this.$store.state.config.lang];
            },
            title() {
                return this.data.section.title;
            },
            hobbies() {
                return this.data.list;
            }
        }
    };
</script>